var $ = require('../internals/export');

// `Number.EPSILON` constant
// https://tc39.github.io/ecma262/#sec-number.epsilon
$({ target: 'Number', stat: true }, {
  EPSILON: Math.pow(2, -52)
});



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/modules/es.number.epsilon.js
// module id = 1354
// module chunks = 1